"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptionCheckMark = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _lodestarIcons = require("@smartsheet/lodestar-icons");
var _react = _interopRequireDefault(require("react"));
var _colors = require("../../../../constants/colors");
var _useTheme = require("../../../../theme/utils/useTheme");
var _checkbox = require("../../../checkbox");
var _MenuCheckboxUrsaSvg = require("../../../menu/components/MenuCheckboxUrsaSvg");
var _contactPickerTheme = require("../../contactPickerTheme");
const OptionCheckMark = _ref => {
  let {
    isOptionSelected,
    singleOrMulti
  } = _ref;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  if (_contactPickerTheme.contactPickerTheme.checkmark.style[singleOrMulti](themeMode) === "checkbox") {
    return /*#__PURE__*/_react.default.createElement(CheckboxStyled, {
      checkedState: isOptionSelected ? "checked" : "unchecked",
      onClick: () => {}
    });
  } else {
    return isOptionSelected ? /*#__PURE__*/_react.default.createElement(OptionCheckMarkWrap, null, getCheckIcon(themeMode)) : null;
  }
};
exports.OptionCheckMark = OptionCheckMark;
const CheckboxStyled = (0, _styled.default)(_checkbox.Checkbox)`
    padding-right: 8px;
    align-self: center;
`;
const OptionCheckMarkWrap = (0, _styled.default)("div")`
    display: flex;
    flex: 1 1 auto;
    justify-content: flex-end;
    align-items: center;
    padding: 0 0 0 12px;
`;
const getCheckIcon = themeMode => {
  switch (themeMode) {
    case "ursa-light":
    case "ursa-dark":
      return /*#__PURE__*/_react.default.createElement(_MenuCheckboxUrsaSvg.MenuCheckboxUrsaSvg, null);
    default:
      return /*#__PURE__*/_react.default.createElement(_lodestarIcons.CheckIcon, {
        color: _colors.buttonPrimary,
        size: "medium"
      });
  }
};
//# sourceMappingURL=OptionCheckMark.js.map